(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('MassApplyController', MassApplyController);

    function MassApplyController($scope, lodash, GenericModel) {
        var options = $scope.$parent.panel.data.options.massApply;
        console.log(options);

        $scope.events = {
            // test: test
            validateForm: validateForm,
            submitApplication: submitApplication,
        };

        $scope.model = {
            application: {
                rad_shift_work_interest: 1,
            },
            selected_jobs: [],
        }


        function test() {
            // if ($scope.events.getModel) {
            //     console.log($scope.events.getModel());
            //     $scope.model.application = $scope.events.getModel();
            //
            //
            // }
        }

        function validateForm() {
            if (lodash.has(options, 'validate_datasource')) {
                var application_form_model = $scope.model.application;

                var url = lodash.get(options, 'validate_datasource.url', '');
                var method = lodash.get(options, 'validate_datasource.method', 'get');
                var model = new GenericModel(url);
                return model[method]({data: application_form_model}).$promise;
            }
        }

        function submitApplication() {
            if (lodash.has(options, 'submission_datasource')) {
                var application_form_model = $scope.model;


                var url = lodash.get(options, 'submission_datasource.url', '');
                var method = lodash.get(options, 'submission_datasource.method', 'post');
                var model = new GenericModel(url);
                return model[method]({data: application_form_model}).$promise;
            }
        }
    }
})();